const initialState = {
  noInternetMessage: null,
};

const noInternet = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    switch (action.type) {
      case 'OFFLINE':
        return {
          ...state,
          noInternetMessage:
            'You are offline, Please check your internet connection',
        };
      case 'ONLINE':
        return {
          ...state,
          noInternetMessage: null,
        };
      default:
        return state;
    }
  }
};

export default noInternet;
